export type BlockingDialogId = 'onboarding' | 'billing' | 'meta-connect';

const blockers = new Set<BlockingDialogId>();
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((l) => {
    try {
      l();
    } catch {
    }
  });
}

export function setBlockingDialog(id: BlockingDialogId, active: boolean): void {
  const before = blockers.size;
  if (active) blockers.add(id);
  else blockers.delete(id);
  if (blockers.size !== before) notify();
}

export function hasBlockingDialog(): boolean {
  return blockers.size > 0;
}

export function subscribeBlockingDialogs(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function __resetBlockingDialogsForTests(): void {
  blockers.clear();
  listeners.clear();
}
